module.exports = __webpack_public_path__ + "img/home-index-menu5.9290b2c6.png";